import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme';

import GalleryPage from './features/blog/ui/pages/GalleryPage';
import GalleryNoTextPage from './features/blog/ui/pages/GalleryNoTextPage';
import ReaderPage from './features/reader/ui/pages/ReaderPage';
import ReaderAuthGatePage from './features/reader/ui/pages/ReaderAuthGatePage';
import AuthCallbackPage from './features/auth/ui/pages/AuthCallbackPage';
import AccessLoginPage from './features/auth/ui/pages/AccessLoginPage';
import ReaderPatreonAuthGatePage from './features/reader/ui/pages/ReaderPatreonAuthGatePage';
import PatreonAuthCallback from './features/auth/ui/pages/PatreonAuthCallback';
import LoginHubPage from './features/auth/ui/pages/LoginHubPage';

export default function App() {
  const basename = (process.env.PUBLIC_URL || '/').replace(/\/$/, '') || '/';

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter basename={basename === '/' ? undefined : basename}>
        <Routes>
          {/* Galleries */}
          <Route path="/" element={<GalleryPage />} />

          {/* Auth callback (provider redirects here) */}
          <Route path="/auth" element={<AuthCallbackPage />} />
          <Route path="/auth-patreon" element={<PatreonAuthCallback />} />
          <Route path="/login" element={<LoginHubPage />} />

          {/* Reader authentication */}
          <Route path="/g/:id/auth" element={<ReaderAuthGatePage />} />
          <Route path="/g/:id/auth-patreon" element={<ReaderPatreonAuthGatePage />} />
          <Route path="/g/:id" element={<ReaderPage />} />
          <Route path="/g/:id/:pageIndex" element={<ReaderPage />} />

          <Route path="/accessLogin" element={<AccessLoginPage />} />
          <Route path="/stories" element={<GalleryPage />} />
          <Route path="/stories-notext" element={<GalleryNoTextPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
